import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71bd9e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buy-form__title" }, "واریز به:", -1))
const _hoisted_2 = { class: "buy-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert = _resolveComponent("alert")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_form_button = _resolveComponent("form-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorMessage = undefined)),
          variant: "danger",
          title: _ctx.errorMessage
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
      class: "buy-form__html"
    }, [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_form_input, {
            modelValue: _ctx.address,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.address) = $event)),
            label: "حساب تتر TRC20",
            "error-message": _ctx.errors.address,
            error: 
            (_ctx.meta.dirty && Boolean(_ctx.errors.address)) || Boolean(_ctx.errors.address)
          ,
            autofocus: "",
            class: _normalizeClass([
            ((_ctx.meta.dirty && Boolean(_ctx.errors.address)) ||
              Boolean(_ctx.errors.address)) &&
              'mb-3',
          ])
          }, null, 8, ["modelValue", "error-message", "error", "class"])
        ])
      ]),
      (_ctx.breakpoints.isMobile)
        ? (_openBlock(), _createBlock(_component_form_button, {
            key: 0,
            loading: _ctx.status === 'loading',
            label: "ادامه",
            "full-width": "",
            type: "submit",
            class: "mb-4 mt-4",
            disabled: !_ctx.address || Boolean(_ctx.errors.address),
            "bordered-disabled": ""
          }, null, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      (_ctx.breakpoints.isDesktop)
        ? (_openBlock(), _createBlock(_component_form_button, {
            key: 1,
            loading: _ctx.status === 'loading',
            label: "ادامه",
            "full-width": "",
            type: "submit",
            class: "mt-4",
            disabled: !_ctx.address || Boolean(_ctx.errors.address),
            disabledBorder: 
        (!_ctx.address || Boolean(_ctx.errors.address)) && _ctx.breakpoints.isMobile
      
          }, null, 8, ["loading", "disabled", "disabledBorder"]))
        : _createCommentVNode("", true)
    ], 32)
  ], 64))
}